import React from "react";
import { StaticQuery, graphql } from "gatsby";

import styles from "./Discord.module.scss";
import classNames from "classnames/bind";

export const DiscordLink = ({ children, className }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "link",
        className
    );

    return (
        <StaticQuery
            query={graphql`
                query DiscordLink {
                    link: site {
                        siteMetadata {
                            discordUrl
                        }
                    }
                }
            `}
            render={data => (
                <a
                    className={classes}
                    href={data.link.siteMetadata.discordUrl}
                    target="_blank"
                    rel="noreferrer"
                >
                    {children}
                </a>
            )}
        />
    )
}